// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCWt-aT1YME42BMF8IZZdF6iKPYTqoe6yI",
  authDomain: "meet-again-1.firebaseapp.com",
  projectId: "meet-again-1",
  storageBucket: "meet-again-1.firebasestorage.app",
  messagingSenderId: "68106661570",
  appId: "1:68106661570:web:fb5df1e1aba30914a3d55b",
  measurementId: "G-49P55LH45Z"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
